const reducer = (state, action) => {
  let nextState = Object.assign({}, state);

  switch (action.type) {
    case 'UPDATE':
      return Object.assign({}, nextState, action.payload);

    case 'UPDATE_SINGLE_CLICKS_LIST':
      return Object.assign({}, nextState, {
        list: action.payload
      });

    case 'SET_PRODUCTS':
      return Object.assign({}, nextState, {
        products: action.payload
      });

    case 'SET_START_DATE':
      return Object.assign({}, nextState, {
        startDate: action.payload
      })

    case 'SET_END_DATE':
      return Object.assign({}, nextState, action.payload);

    default:
      return nextState;
  }
}

export default reducer;